var LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
var LOCAL_STORAGE_DELIMITER = ',';
var BUTTON_ACTIVE_CLASS = 'active';
var GetAllCartsData=[];
var cartCount = '{{ cart.item_count }}';

var selectors = {
  button: '[button-wishlist]',
  grid: '[grid-wishlist]',
};

function wishiconset(button)
{
  console.log(button);
  $(button).addClass('fa-heart');
   $(button).removeClass('fa-heart-o');

}
function wishiconset1(button)
{
  
  $(button).addClass('fa-heart-o');
   $(button).removeClass('fa-heart');

}
// $(".plistaddtocart").hover(function () {
// 	console.log('test');
// 	$(this).addClass("fa-heart");
//     $(this).removeClass("fa-heart-o");
// });
function Addwish(button) {
//  	$(this).addClass("fa-heart");
//     $(this).removeClass("fa-heart-o");
//   var x = document.querySelectorAll(".addwish");
//   if (x.length) setupButtons(x);
//   console.log(button);
   var productHandle = button.dataset.productHandle || false;
    if (!productHandle) return console.log('[Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
    if (wishlistContains(productHandle)) button.classList.add(BUTTON_ACTIVE_CLASS);
    updateWishlist(productHandle);
    //console.log(productHandle);
    button.classList.toggle(BUTTON_ACTIVE_CLASS);
//      $(button).addClass('fa-heart-o');
//     $(button).removeClass('fa-heart');
    $(button).find('i').addClass('fa-heart');
    $(button).find('i').removeClass('fa-heart-o');
  
    if (button.length) setupButtons(button);
  
  	countwish();

}
(function($) {
    $.fn.clickToggle = function(func1, func2) {
        var funcs = [func1, func2];
        this.data('toggleclicked', 0);
        this.click(function() {
            var data = $(this).data();
            var tc = data.toggleclicked;
            $.proxy(funcs[tc], this)();
            data.toggleclicked = (tc + 1) % 2;
        });
        return this;
    };
}(jQuery));

// $('.addwish').clickToggle(function() {
//   var x = document.querySelectorAll(".addwish");
//   if (x.length) setupButtons(x);
// }, function() {
//   var x = document.querySelectorAll(".addwish");
//   if (x.length) setupButtons(x);
// });

$(function(){
  $(window).scroll(function(){
    var aTop = $('#Collection').height();
  //var hT = $('#Collection').offset().top;
      var hH = $('#Collection').outerHeight();
   var wH = $(window).height();
    var wS = $(this).scrollTop();
     if (wS > (hH-wH)){
       //console.log(dynamicimage);
       var imgAry=['https://cdn.shopify.com/s/files/1/0561/2965/0862/files/bride-holds-up-wedding-ring.jpg?v=1622695262','https://cdn.shopify.com/s/files/1/0561/2965/0862/files/a-close-up-of-the-brides-wedding-ring-and-band.jpg?v=1622695171'];
       var setimg=[];
       if (window.matchMedia('(max-width: 749px)').matches || window.matchMedia('(max-width: 768px)').matches) {
       }
       else{
         fetchCart();
         if(dynamicimage.length!=0)
         {
           $.each( dynamicimage, function( key, value ) {
            if(value[0].toLowerCase()==value[1].toLowerCase())
            {

              var htmlll='<div class="pdlist grid__item small--one-half medium-up--one-quarter productgridmain boost-pfs-action-list-enabled" >'+ 
                          '<div class="grid-view-item" style="text-align: center;">'+
                              '<a href="'+value[2]+'"><img src="'+value[3]+'" style="height: 369px;"></a>'+
                          '</div>'+
                       '</div>';
              setimg.push(htmlll); 
            }
          }); 
          $('.productgridlist').find('.pdlist').each(function(){
              //console.log($(this).attr('data-page'));
            var last = $(this).parent().find('.pdlist:last').attr('data-page');
           if(setimg.length!=0 && last==1)
           {
             $('.productgridlist').append(setimg[0]);
           }
           if(setimg.length!=1 && last==4)
           {
             $('.productgridlist').append(setimg[1]);
           }

          });
         }
       }
       
     }
    var buttons = document.querySelectorAll(".addwish") || [];
    if (buttons.length) setupButtons(buttons);
  });
});
 window.addEventListener('load', function() {
   var buttons = document.querySelectorAll(".addwish") || [];
    if (buttons.length) setupButtons(buttons);

    var grid = document.querySelector('.grid-wishlist') || false;
    if (grid) setupGrid(grid);

});


var setupGrid = function (grid) {
  var wishlist = getWishlist();
  var requests = wishlist.map(function (handle) {
    var productTileTemplateUrl = '/products/' + handle + '?view=card';
    //console.log(productTileTemplateUrl);
    return fetch(productTileTemplateUrl).then(function (res) {
      return res.text();
       //console.log(res.text());
    });
  });
  Promise.all(requests).then(function (responses) {
    var wishlistProductCards = responses.join('');
    grid.innerHTML = wishlistProductCards;
    var buttons = grid.querySelectorAll(selectors.button) || [];
    if (buttons.length) setupButtons(buttons);
  });
};

var setupButtons = function (buttons) {
  buttons.forEach(function (button) {
    var productHandle = button.dataset.productHandle || false;
    if (!productHandle) return console.log('[Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
    if (wishlistContains(productHandle)){ 
      button.classList.add(BUTTON_ACTIVE_CLASS);
      $(button).find('i').addClass('fa-heart');
      $(button).find('i').removeClass('fa-heart-o');
      countwish();
    }
//     button.addEventListener('click', function () {
//       updateWishlist(productHandle);
//       console.log('1');
//       button.classList.toggle(BUTTON_ACTIVE_CLASS);
//     });
    
     
  });
};

var getWishlist = function () {
  var wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
  return [];
};
countwish();
function allStorage() 
{

    var values = [],
        keys = Object.keys(localStorage),
        i = keys.length;

    while ( i-- ) {
        values.push( localStorage.getItem(keys[i]) );
    }

    return values;
}

function countwish()
{

    var Item = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY);
  	if(Item!=null)
    {
      var CountWish = Item.split(",");
      $('.wishitemcount1').text(CountWish.length);
     //     console.log(CountWish.length); 
    }
    else
    {
      	$('.wishitemcount1').text(0);
    }

  }

var setWishlist = function (array) {
  var wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length){
    localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
    
  }
  else{
    localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);
    countwish();
    
  }
  setTimeout(function() { CollectionPagecloseModal1(); }, 5000);
  return wishlist;
};
var setWishlist1 = function (array) {
  var wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length){
    localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
    
  }
  else{
    localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);
    countwish();
    
  }
  return wishlist;
};

var updateWishlist = function (handle) {
  //console.log('dd-'+handle);
  var wishlist = getWishlist();
  var indexInWishlist = wishlist.indexOf(handle);
  if (indexInWishlist === -1) {
    wishlist.push(handle);
    CollectionPageMsgPopup('Successfully added product to your Wishlist.');
    countwish();
  }
  else{
    wishlist.splice(indexInWishlist, 1);
    CollectionPageMsgPopupError('Successfully removed product from your Wishlist.');
    countwish();
  }
  return setWishlist(wishlist);
};

var wishlistContains = function (handle) {
  var wishlist = getWishlist();
  return wishlist.indexOf(handle) !== -1;
};

var resetWishlist = function () {
  return setWishlist([]);
};

if(getWishlist().length!=0)
{
  $('.grid-wishlist').show();
  $('.wishlistmainheader').show();
  $('.wishnotfound').hide();
}
else
{
  $('.wishnotfound').show();
  $('.wishlistmainheader').hide();
  
}

function CollectionPageMsgPopup(msg) 
{
  		cartCount++;
//   $('.modal1').css('background','#4BB543');
//   $('.modal1').css('border','1px solid #4BB543');
  $('.modal1').css('background','#b50a37');
  $('.modal1').css('border','1px solid #b50a37');
  
    $('.modal1')
    .html('<span class="close" id="close" onclick="CollectionPagecloseModal1()">✕</span><span class="" style="display:flex;align-items:center;padding-top: 3px;font-size: 16px;width: 320px;letter-spacing: 1px;"><i class="fa fa-check-circle" style="font-size: 27px;padding-right:8px;"></i>  ' + msg + ' </span>');
    $('#cart-number')
    .replaceWith('<a href="/cart" id="cart-number">View cart(' + cartCount + ')</a>');
    CollectionPageopenModal();
    
}
function CollectionPageMsgPopupError(msg) 
{
  		cartCount++;
  $('.modal1').css('background','#b50a37');
  $('.modal1').css('border','1px solid #b50a37');
    $('.modal1')
    .html('<span class="close" id="close" onclick="CollectionPagecloseModal1()">✕</span><span class="" style="display:flex;align-items:center;padding-top: 3px;font-size: 16px;width: 320px;letter-spacing: 1px;"><i class="fa fa-times-circle" style="font-size: 27px;padding-right:8px;"></i>  ' + msg + ' </span>');
    $('#cart-number')
    .replaceWith('<a href="/cart" id="cart-number">View cart(' + cartCount + ')</a>');
    CollectionPageopenModal();
}
//center modal based on window size
function CollectionPagecenterModal() 
{
    var modal = $('.modal1.open');
    var mWidth = modal.outerWidth();
    var mHeight = modal.outerHeight();
    var width = $(window)
    .width();
    var height = $(window)
    .height();
    if ((width % 1) != 0) {
      width = Math.round(width);
    }
    if ((height % 1) != 0) {
      height = Math.round(height);
    }
    var topPos = (height / 2) - (mHeight / 2);
    var leftPos = (width / 2) - (mWidth / 2);
//     modal.css({top: topPos, left: leftPos});
  	  if (window.matchMedia('(max-width: 767px)').matches) {
          modal.css({top: '0px', right: '0%'}); 
      }
  	  else if (window.matchMedia('(min-width: 1920px)').matches) {
          modal.css({top: '0px', right: '0%'}); 
      }
  	  else if (window.matchMedia('(min-width: 1024px)').matches && window.matchMedia('(max-width: 1366px)').matches) {
          modal.css({top: '0px', right: '0%'}); 
      }
      else{
        modal.css({top: '0px', right: '0%'}); 
        //modal.css({top: '0px', left: '61%'});
      }
    
    
}
  //open modal and overlay
function CollectionPageopenModal() {
    $('.modal1').css('display','block');
    $('.modal1')
    .removeClass('hidden')
    .addClass('open');
    $('.modal1--overlay')
    .removeClass('hidden')
    .addClass('open');
    CollectionPagecenterModal();
}
  //close modal and overlay
function CollectionPagecloseModal(overlay) {
    $(overlay)
    .addClass('hidden')
    .removeClass('open');
    $('.modal1.open')
    .addClass('hidden')
    .removeClass('open');
   
}
function CollectionPagecloseModal1() {
     $('.modal1').css('display','none');
     $('.modal1--overlay')
    .addClass('hidden')
    .removeClass('open');
    
}
function addItem(form_id,handle,id) 
{
   var added=false;
  //console.log(id);
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function(cart) {
     
      if(cart.items.length!=0)
      {
       
        $.map(cart.items, function(elementOfArray, indexInArray) {
          console.log(elementOfArray);
         if (elementOfArray.product_id == id) {
           added = true;
         }
        });
        if (!added) 
        {
          CartProductadd(form_id,handle,id); 
        }
        else
        {
           CollectionPageMsgPopupError('Product Already Exists in Cart List.');
        }


      }
      else
      {
        CartProductadd(form_id,handle,id); 
        
      }

    },
  });
    

}

function CartProductadd(form_id,handle,id) 
{
  $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: $('#' + form_id)
      .serialize(),
      success: function(line_item) { 
        CollectionPageMsgPopup('successfully added product to your cart');
        $('.shoppingbagicon'+id).addClass('carticonactive');
        fetchCart();
        setTimeout(function() { CollectionPagecloseModal1(); }, 5000);
      },
      error: function(XMLHttpRequest, textStatus) {
        fetchCart();
        CollectionPageMsgPopupError('Sorry! Currently product is Out of Stock');
      }
    });


}
function relatedaddItem(form_id,sectionid) 
{
  
    if($(".pseccheck"+sectionid).prop('checked') == true)
    {
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: $('.' + form_id)
        .serialize(),
        success: function(line_item) { 

          CollectionPageMsgPopup('successfully added product to your cart');
         // getAllCartData();
          setrelatedproduct();
          fetchCart();
          setTimeout(function() { CollectionPagecloseModal1(); }, 5000);

        },
        error: function(XMLHttpRequest, textStatus) {
          //console.log(XMLHttpRequest.responseJSON.description);
          CollectionPageMsgPopupError(XMLHttpRequest.responseJSON.description);
        }
      });
    }
  	else
    {
      	
   		var line=$(".pseccheck"+sectionid).attr('data-key');
      	console.log(line);
        $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data: 'quantity=0' + '&line=' + line,
          dataType: 'json',
          async: false,
          success: function(cart) {
                CollectionPageMsgPopup('successfully removed product to your cart');
                setrelatedproduct();
            	fetchCart();
                setTimeout(function() { CollectionPagecloseModal1(); }, 5000);
          },
          error: function(XMLHttpRequest, textStatus) {
            CollectionPageMsgPopupError(XMLHttpRequest.responseJSON.description);
          }
    	});
    }



}
function quickview($e){
//   const body = document.querySelector("body");
//   body.style.overflow = "hidden";
//     console.log('test');
 
  
}
